import React, {useState} from "react";
import {Button, Checkbox, Col, Row} from "antd";
import {DiamondIcon, FlameIcon, PriceListIcon, StorageBoxOutlineIcon} from "@components/icons/Icons";
import {FmvPrice} from "@components/fmv-price";
import {KeyIssueBadge} from "@components/key-issue-badge";
import {Link} from "react-router-dom";
import {getMyCollectionUrlWithIssueId} from "@lib/Routes";
import {RightOutlined} from "@ant-design/icons";
import {getDefaultFmvDataFromIssue} from "@components/comic-grade-select";

const IssuesListItemMobileNoImage = ({
      item,
      showEditMultiple,
      isSelected,
      toggleSelected,
      onClick,
      issueDate,
      showValueRibbon,
      allowUnlimited,
      navigate,
      windowDimensions,
      showListViewNoImages,
      setPriceListId,
      isLoggedIn,
      wishlistIssueAdd,
      wishlistIssueRemove,
      setAddIssueId,
      shopLink,
}) => {
    const [fmvData, setFmvData] = useState(getDefaultFmvDataFromIssue(item));

    return (
        <div className="grid-list-item with-hover mar-left-10">
            <Row className={"grid-list-item-inner"}>
                <Col span={23}>
                    <Row>
                        <Col span={12} className="flex-row flex-vertical-center">
                            {(showEditMultiple && toggleSelected) && (
                                <Checkbox className="mar-right-10" checked={isSelected}
                                          onChange={() => toggleSelected(item.id)}/>
                            )}
                            {(item.is_key || item.is_hot || item.is_rare) && (
                                <div className="valueBadges mar-right-10">
                                    {item.is_key && (
                                        <KeyIssueBadge keyInfo={item.key_info} windowDimensions={windowDimensions}
                                                       isLargeScreen={false}/>)}
                                    {item.is_hot && (<div className="valueBadge hotIssue isActive"><FlameIcon/></div>)}
                                    {item.is_rare && (
                                        <div className="valueBadge rareIssue isActive"><DiamondIcon/></div>)}
                                </div>
                            )}
                            {item.total_in_collection > 0 && (
                                <Link to={getMyCollectionUrlWithIssueId(item.id)}>
                                <span className="issues-owned">
                                    <StorageBoxOutlineIcon/><strong>&nbsp;:&nbsp;<span
                                    className="total-number">{item.total_in_collection}</span></strong>
                                </span>
                                </Link>
                            )}
                        </Col>

                        <Col span={12} className="flex-align-right flex-vertical-center">
                            <Button
                                onClick={() => setPriceListId(item.id)}
                                type="link"
                                className={'price-list-btn'}
                                icon={<PriceListIcon className={`icon16 `}/>}
                            >Price Table</Button>
                        </Col>
                    </Row>

                    <Row className="item-title">
                        <Col span={24}>
                            {item.issue_number} - {(item.variant_name && item.variant_name !== '') ? item.variant_name : 'Regular'} - {issueDate.getFullYear()}
                        </Col>
                    </Row>

                    <div style={{marginRight: 10, marginTop: 10}}>
                        <Row className={"grade-boxes"} gutter={[10, 10]}>
                            <Col span={12}>
                                <Row>
                                    <Col span={8} className={"raw-title"}>RAW</Col>
                                    <Col span={6} className={"raw-text"}>
                                    <span className={(item.raw_fmv_stale ? 'fmv-price-stale' : '')}>
                                        {item.raw_fmv_grade}
                                    </span>
                                    </Col>
                                    <Col span={10} className={"raw-text"}>
                                        {showValueRibbon ? (
                                            <FmvPrice value={item.raw_fmv_value} stale={item.raw_fmv_stale}/>
                                        ) : (
                                            <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={8} className={"slab-title"}>SLAB</Col>
                                    <Col span={6} className={"slab-text"}>
                                    <span className={(item.slabbed_fmv_stale ? 'fmv-price-stale' : '')}>
                                        {item.slabbed_fmv_grade}
                                    </span>
                                    </Col>
                                    <Col span={10} className={"slab-text"}>
                                        {showValueRibbon ? (
                                            <FmvPrice value={item.slabbed_fmv_value} stale={item.slabbed_fmv_stale}/>
                                        ) : (
                                            <a className="upgrade-link" href="/plans/unlimited/">Upgrade</a>
                                        )}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Col>

                <Col span={1} className="flex-vertical-center mobile-chevron-btn">
                    <Button type="text" href={`/issue/${item.slug}`} style={{padding: 0, width: '100%'}}>
                        <RightOutlined/>
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default IssuesListItemMobileNoImage;